import React from 'react';

export const StampingContext = React.createContext();
